import {useMemo, useState} from 'react';
import { Capacitor } from "@capacitor/core";
import ukMoment from "../../../../utils/ukTime";

import StudioSelector from "./StudioSelector";
import WeekSelector from "./WeekSelector";
import Sessions from "./Sessions";
import Header from "../../../components/Header";
import Loading from "../../../components/Loading";

import styles from '../../../../styles/Calendar.module.scss';

function Calendar({
	studio,
	setStudio,
	week,
	setWeek,
	studios,
	selectedSessions,
	toggleSession,
	removeSession,
	clearCart,
	createBulkBookings,
	booking,
	error,
	user,
	domain,
	maxWeek = 3
}) {

	const [loading, setLoading] = useState(true);

	const start = useMemo(() => {
		const today = new Date();
		today.setUTCHours(0, 0, 0, 0);
		const dayOfWeek = today.getUTCDay();
		const monday = today.getUTCDate() - ((dayOfWeek + 6) % 7);
		today.setUTCDate(monday + (7 * week));
		return today;
	}, [week]);
	const end = useMemo(() => {
		const endDate = new Date(start);
		endDate.setUTCDate(endDate.getUTCDate() + 7);
		return endDate;
	}, [start]);
	
	const requiresActivation = domain?.requireActivation && !user?.admin && !user?.isActive;
	const isHybrid = domain?.businessType === 'hybrid' || domain?.businessType === 'hybrid-new';
	const tokenCost = isHybrid ? Number(domain?.openGymTokenCost ?? 1) : 1;
	const requiredTokens = selectedSessions.length * tokenCost;
	const availableTokens = isHybrid ? Number((domain?.businessType === 'hybrid-new' ? user?.openGymBalance : user?.walletBalance) || 0) : Number(user?.balance || 0);
	const hasEnoughTokens = availableTokens >= requiredTokens;

	return (
		<>
			{Capacitor.isNativePlatform() && <Header heading={"Create Booking"} />}
			<div className={styles.calendar}>
				<div className={styles.controls}>
					<StudioSelector studio={studio} setStudio={setStudio} studios={studios} loading={loading} setLoading={setLoading} />
					<WeekSelector week={week} setWeek={setWeek} loading={loading} setLoading={setLoading} maxWeek={maxWeek} />
				</div>
				<Sessions
					studio={studio}
					start={start}
					end={end}
					loading={loading}
					setLoading={setLoading}
					selectedSessions={selectedSessions}
					toggleSession={toggleSession}
					user={user}
				/>
				{selectedSessions.length > 0 && (
					<div className={styles.cart}>
						<div>
							<h2>Cart</h2>
							{error && <p className={styles.error}>{error}</p>}
							{requiresActivation && <p className={styles.error}>Your account is awaiting activation. Please contact the business to complete your activation.</p>}
							{!hasEnoughTokens && <p className={styles.error}>You need {requiredTokens} tokens to book these sessions.</p>}
							<div className={styles.cartItems}>
								{selectedSessions.map((session) => (
									<div key={`${session.studio?._id}-${session.start}-${session.end}`} className={styles.cartItem}>
										<div>
											<span>{ukMoment(session.start).format("ddd Do MMM, HH:mm")}</span>
											<span>{session.studio?.name}</span>
										</div>
										<button type="button" onClick={() => removeSession(session)}>
											Remove
										</button>
									</div>
								))}
							</div>
						</div>
						<div className={styles.cartActions}>
							<button type="button" className="btn btnEmpty" onClick={clearCart} disabled={booking}>Clear</button>
							<button
								type="button"
								className="btn btnPrimary"
								onClick={createBulkBookings}
								disabled={booking || requiresActivation || !hasEnoughTokens}
							>
								{booking ? <Loading button={true} /> : `Book ${selectedSessions.length} session${selectedSessions.length === 1 ? "" : "s"}${requiredTokens ? ` (${requiredTokens} token${requiredTokens === 1 ? "" : "s"})` : ""}`}
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	)
}

export default Calendar;
